/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Department = {

	delete (context, id, onSuccess, onError, options) {
		Api.delete(context,
			"/department"
			+ "?id=" + id
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContractTemplates (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/department/contract-templates"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCorrespondences (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/department/correspondences"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDonationContractTemplates (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/department/donation-contract-templates"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getList (context, onSuccess, onError, options) {
		Api.get(context,
			"/department/list"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getName (context, depId, onSuccess, onError, options) {
		Api.get(context,
			"/department/name"
			+ "?depId=" + depId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postAdd (context, request, onSuccess, onError, options) {
		Api.post(context,
			"/department/add"
			, request
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putEdit (context, request, onSuccess, onError, options) {
		Api.put(context,
			"/department/edit"
			, request
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
